import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnBoardingPage from './OnBoardingPage';

const OnBoardingPageWrapper = () => {
  const navigate = useNavigate();
  
  // Navigation Integration - matching TutorialPage pattern
  return <OnBoardingPage navigate={navigate} />;
};

export default OnBoardingPageWrapper;
